import React from 'react';
import './SupportRow.css';

const SupportRow = (props) => {
    return (
        <div className="sur-row">
            <div className="sur-avatar">
                <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="10" cy="7" r="3" stroke="currentColor" strokeWidth="1.5"/>
                    <path d="M4 17c0-3.314 2.686-6 6-6s6 2.686 6 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                </svg>
            </div>
            <div className="sur-info">
                <p className="sur-name">{props.name}</p>
                <p className="sur-email">{props.email}</p>
                <p className="sur-msg">{props.message}</p>
                <p className="sur-time">{props.time}</p>
            </div>
        </div>
    );
};

export default SupportRow;